import React, { useState, useEffect } from 'react';
import { Link as Anchor, useLocation } from 'react-router-dom';
import logo from '../../images/logo.jpeg';
import Profile from '../Profile/Profile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faChevronRight, faCircle } from '@fortawesome/free-solid-svg-icons';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    // Efecto de scroll para el header
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Bloquear scroll cuando el menú está abierto
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    }, [isOpen]);

    const isActive = (path) => location.pathname === path;

    return (
        <>
            <style>
                {`
                .ido-header {
                    position: fixed;
                    top: 0;
                    width: 100%;
                    z-index: 1000;
                    background: ${scrolled ? 'rgba(0, 0, 0, 0.95)' : 'black'};
                    backdrop-filter: blur(10px);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                    height: 80px;
                    display: flex;
                    align-items: center;
                    transition: all 0.3s ease;
                }

                .ido-nav-container {
                    width: 100%;
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 0 25px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                /* LOGO: Si es el logo original, le damos brillo para que resalte en negro */
                .ido-logo img {
                    height: 40px;
                    width: auto;
                    filter: ${scrolled ? 'none' : 'brightness(1.1)'};
                }

                .ido-desktop-menu {
                    display: flex;
                    gap: 35px;
                }

                .ido-nav-link {
                    text-decoration: none;
                    color: rgba(255, 255, 255, 0.7);
                    font-weight: 700;
                    font-size: 0.75rem;
                    letter-spacing: 2px;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .ido-nav-link:hover {
                    color: white;
                }

                .ido-nav-link.active {
                    color: #FF0000;
                }

                .nav-dot {
                    font-size: 4px;
                    color: #FF0000;
                    display: none;
                }

                .ido-nav-link.active .nav-dot {
                    display: inline;
                }

                /* BOTÓN TOGGLE MOBILE */
                .nav-toggle-btn {
                    display: none;
                    background: transparent;
                    color: white;
                    border: 1px solid rgba(255,255,255,0.2);
                    width: 45px;
                    height: 45px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 1.2rem;
                    transition: all 0.3s ease;
                }

                .nav-toggle-btn:active {
                    background: #FF0000;
                    border-color: #FF0000;
                }

                /* MENU MOBILE OVERLAY */
                .mobile-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100vh;
                    background: #000;
                    z-index: 2000;
                    display: flex;
                    flex-direction: column;
                    padding: 30px;
                    transform: translateX(100%);
                    transition: transform 0.4s cubic-bezier(0.7, 0, 0.3, 1);
                }

                .mobile-overlay.open {
                    transform: translateX(0);
                }

                .mobile-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 50px;
                }

                .close-btn {
                    background: #111;
                    border: 1px solid #333;
                    color: white;
                    width: 45px;
                    height: 45px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .mobile-links {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }

                .mobile-link {
                    color: white;
                    text-decoration: none;
                    font-size: 2rem;
                    font-weight: 900;
                    letter-spacing: -1px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 15px 0;
                    border-bottom: 1px solid #111;
                }

                .mobile-link span {
                    color: #FF0000;
                    font-family: monospace;
                    font-size: 0.9rem;
                    margin-right: 15px;
                }

                .mobile-footer {
                    margin-top: auto;
                    padding-bottom: 20px;
                }

                @media (max-width: 991px) {
                    .ido-desktop-menu { display: none; }
                    .nav-toggle-btn { display: flex; align-items: center; justify-content: center; }
                }
                `}
            </style>

            <header className="ido-header">
                <nav className="ido-nav-container">
                    <Anchor to="/" className="ido-logo">
                        <img src={logo} alt="IDO - Movilidad Japonesa" />
                    </Anchor>

                    {/* Desktop Menu */}
                    <div className="ido-desktop-menu">
                        <Anchor to="/" className={`ido-nav-link ${isActive('/') ? 'active' : ''}`}>
                            <FontAwesomeIcon icon={faCircle} className="nav-dot" /> INICIO
                        </Anchor>
                        <Anchor to="/stock/autos" className={`ido-nav-link ${isActive('/stock/autos') ? 'active' : ''}`}>
                            <FontAwesomeIcon icon={faCircle} className="nav-dot" /> VEHÍCULOS
                        </Anchor>

                        <Anchor to="/nosotros" className={`ido-nav-link ${isActive('/nosotros') ? 'active' : ''}`}>
                            <FontAwesomeIcon icon={faCircle} className="nav-dot" /> NOSOTROS
                        </Anchor>
                    </div>

                    <div className="ido-nav-actions">
                        <button className="nav-toggle-btn" onClick={() => setIsOpen(true)}>
                            <FontAwesomeIcon icon={faBars} />
                        </button>
                    </div>
                </nav>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-overlay ${isOpen ? 'open' : ''}`}>
                    <div className="mobile-header">
                        <img src={logo} alt="logo" style={{ height: '35px' }} />
                        <button onClick={() => setIsOpen(false)} className="close-btn">
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>

                    <div className="mobile-links">
                        <Anchor to="/" onClick={() => setIsOpen(false)} className="mobile-link">
                            <div><span>01/</span> INICIO</div>
                            <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '1rem', color: '#333' }} />
                        </Anchor>
                        <Anchor to="/stock/autos" onClick={() => setIsOpen(false)} className="mobile-link">
                            <div><span>02/</span> VEHÍCULOS</div>
                            <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '1rem', color: '#333' }} />
                        </Anchor>
                        <Anchor to="/nosotros" onClick={() => setIsOpen(false)} className="mobile-link">
                            <div><span>04/</span> NOSOTROS</div>
                            <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '1rem', color: '#333' }} />
                        </Anchor>
                    </div>

                    <div className="mobile-footer">
                        <div style={{ background: '#111', padding: '20px', borderRadius: '8px', border: '1px solid #222' }}>
                            <Profile />
                        </div>
                        <p style={{ color: '#444', fontSize: '0.65rem', marginTop: '20px', textAlign: 'center', letterSpacing: '3px' }}>
                            IDO BY GRUPO ANTUN // V.2026
                        </p>
                    </div>
                </div>
            </header>
            {/* Espaciador para que el contenido no empiece debajo del nav fijo */}
        </>
    );
}